import Image from "next/image";
import React from "react";
import styles from "./upsc-sociology-optional.module.css";
import Carousel from 'react-bootstrap/Carousel';
import carouselBGimg3 from "../../assets/images/home/Moksha/Sociology-Web-Banner.jpg";
import carouselBGimg4 from "../../assets/images/home/Moksha/Sociology-Mobile-Banner.jpg";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import Upsc_toppers from "./toppers";
import Link from "next/link";
import Head from "next/head";

const UPSC_Main_Test_Series_2023 = () => {
        // const BGimg = [
        //         { img: carouselBGimg4, alt: "carousel", link: "/" },
        //         { img: carouselBGimg3, alt: "carousel", link: "/upsc-mains-test-series" }
        // ]
        return (
                <>

                        <Head>
                                <meta charset="UTF-8" />

                                <meta name="viewport" content="width=device-width, initial-scale=1" />
                                <meta name="robots" content="noodp,noydir" />
                                <meta name="robots" content="index,follow" />
                                <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
                                <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
                                <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
                                <title>UPSC Sociology Mains Test Series 2026</title>
                                <meta name="title" content="UPSC Sociology Mains Test Series 2026" />
                                <meta name="description" content="Prepare with UPSC Sociology Mains Test Series 2026 from Shankar IAS Academy. Practice tests, expert feedback & exam-ready strategies." />
                                <link rel="canonical" href=" https://www.shankariasacademy.com/upsc-sociology-mains-test-series/" />
                                <meta property="og:locale" content="en_US" />
                                <meta property="og:type" content="article" />
                                <meta property="og:title" content="UPSC Sociology Mains Test Series 2026" />
                                <meta property="og:description" content="Prepare with UPSC Sociology Mains Test Series 2026 from Shankar IAS Academy. Practice tests, expert feedback & exam-ready strategies." />
                                <meta property="og:url" content=" https://www.shankariasacademy.com/upsc-sociology-mains-test-series/" />
                                <meta property="og:site_name" content="Shankar IAS Academy" />
                                <meta name="twitter:card" content="summary_large_image" />
                                <meta name="twitter:site" content="@shankarias" />
                        </Head>


                        <Navbar title="upsc" />

                        <div className="container">
                                <div className="row pt-3 pt-md-4">
                                        <div className="col-md-8 col-6 ">
                                                <h1 className={`${styles.pagemaintitle}`}>UPSC Sociology Mains Test Series 2026</h1>
                                        </div>
                                        <div className="col-md-2 col-2 offset-md-2 mt-md-3">
                                                <a href="https://admissions.shankariasacademy.com/online/" target="_blank" className={`${styles.normalbutton}  d-inline-block text-center align-middle`}>Moksha Login</a>
                                        </div>
                                </div>
                                
                               <div className="container">
                                     <div className="row d-none d-md-block">
                                         <div className="col mb-3">
                                           <Image
                                             src={carouselBGimg3}
                                             alt="orientation banner"
                                             title="UPSC orientation Test Series 2024"
                                             className="img-fluid w-100"
                                           />
                                         </div>
                                     </div>
                               
                                     <div className="row d-block d-md-none">
                                       <div className="col mb-3">
                                         <Image
                                           src={carouselBGimg4}
                                           alt="orientation banner"
                                           title="UPSC orientation"
                                           className="img-fluid w-100"
                                         />
                                       </div>
                                     </div>
                                </div>
                               
                              
                        </div>


                        {/* Mains 2026 */}

                        <div className="container py-5 d-none d-md-block">
                                <div className={styles.compareTable}>

                                        {/* Header */}
                                        <div className={`${styles.tableRow} ${styles.tableHeader}`}>
                                                <div className={styles.featureCol}>
                                                        <h4>Choose Your Best Fit</h4>
                                                </div>

                                                <div className={styles.planCol}>
                                                        <div className={styles.planCard}>
                                                                <h5>FRESHERS</h5>
                                                                <span>Ideal for Freshers</span>
                                                        </div>
                                                </div>

                                                <div className={styles.planCol}>
                                                        <div className={styles.planCard}>
                                                                <h5>VETERANS</h5>
                                                                <span>Experienced</span>
                                                        </div>
                                                </div>

                                                <div className={styles.planCol}>
                                                        <div className={styles.planCard}>
                                                                <h5>LONG TERM</h5>
                                                                <span>Exhaustive Practice</span>
                                                        </div>
                                                </div>
                                        </div>

                                        {/* Row 1 */}
                                        <div className={styles.tableRow}>
                                                <div className={styles.featureCol}>
                                                        <p className={styles.featureTitle}>Whom?</p>
                                                </div>

                                                <div className={styles.planCol}>
                                                        <p>
                                                                Suits aspirants appearing for Mains 2026
                                                        </p>
                                                </div>

                                                <div className={styles.planCol}>
                                                        <p>
                                                                Suits aspirants with prior mains experience and
                                                                appearing for Mains 2026
                                                        </p>
                                                </div>

                                                <div className={styles.planCol}>
                                                        <p>
                                                                Suits aspirants who want exhaustive optional
                                                                answer writing practice for Mains 2027
                                                        </p>
                                                </div>
                                        </div>

                                        {/* Row 2 */}
                                        <div className={styles.tableRow}>
                                                <div className={styles.featureCol}>
                                                        <p className={styles.featureTitle}>Tests</p>
                                                </div>

                                                <div className={styles.planCol}>
                                                        <p> 6 Sectional Test + 4 Full Test</p>
                                                </div>

                                                <div className={styles.planCol}>
                                                        <p>6 Full Tests</p>
                                                </div>

                                                <div className={styles.planCol}>
                                                        <p>
                                                                7 Sectional Test + 3 Revision Test + 2 Full Test
                                                        </p>
                                                </div>
                                        </div>

                                        {/* Row 3 */}
                                        <div className={styles.tableRow}>
                                                <div className={styles.featureCol}>
                                                        <p className={styles.featureTitle}>Schedule</p>
                                                </div>

                                                <div className={`${styles.planCol} text-center`}>
                                                        <a
                                                                // href="#"
                                                                href="https://www.shankariasacademy.com/pdf/UPSC-2026/Moksha-Optional/Sociology/Sociology-Freshers-2026.pdf"
                                                                target="_blank"
                                                                className={styles.pdfBtn}
                                                        >
                                                                <i className="bi bi-file-earmark-pdf-fill"> </i>
                                                        View PDF

                                                        </a>
                                                </div>

                                                <div className={`${styles.planCol} text-center`}>
                                                        <a
                                                                // href="#"
                                                                href="https://www.shankariasacademy.com/pdf/UPSC-2026/Moksha-Optional/Sociology/Sociology-Veterans-2026.pdf"
                                                                target="_blank"
                                                                className={styles.pdfBtn}
                                                        >
                                                                {/* <i className="bi bi-file-earmark-pdf-fill"> </i> */}
                                                                <i className="bi bi-file-earmark-pdf-fill"></i>
                                                                View PDF
                                                                
                                                        </a>
                                                </div>

                                                <div className={`${styles.planCol} text-center`}>
                                                        <a
                                                                // href="#"
                                                                href="https://www.shankariasacademy.com/pdf/UPSC-2026/Moksha-Optional/Sociology/Sociology-LongTerm-2026.pdf"
                                                                target="_blank"
                                                                className={styles.pdfBtn}
                                                        >
                                                                {/* <i className="bi bi-file-earmark-pdf-fill"> </i> */}
                                                                <i className="bi bi-file-earmark-pdf-fill"></i>

                                                               View PDF
                                                        </a>
                                                </div>
                                        </div>

                                        {/* Row 4 */}
                                        <div className={styles.tableRow}>
                                                <div className={styles.featureCol}>
                                                        <p className={styles.featureTitle}>Admission</p>
                                                </div>

                                                <div className={`${styles.planCol} text-center`}>
                                                        <a
                                                                href="https://admissionsv1.shankariasacademy.com/"
                                                                target="_blank"
                                                                className={styles.admissionBtn}
                                                        >
                                                                Pay Now
                                                        </a>
                                                </div>

                                                <div className={`${styles.planCol} text-center`}>
                                                        <a
                                                                href="https://admissionsv1.shankariasacademy.com/"
                                                                target="_blank"
                                                                className={styles.admissionBtn}
                                                        >
                                                                Pay Now
                                                        </a>
                                                </div>

                                                <div className={`${styles.planCol} text-center`}>
                                                        <a
                                                                href="https://admissionsv1.shankariasacademy.com/"
                                                                target="_blank"
                                                                className={styles.admissionBtn}
                                                        >
                                                                Pay Now
                                                        </a>
                                                </div>
                                        </div>

                                </div>
                        </div>

                        {/* Mobile View */}

                        <div className="container-fluid py-4 d-block d-md-none" id="gsttestseries">
                                <div className={styles.mobileWrapper}>
                                        <div className="container">
                                                <h2 className={styles.mobileMainTitle}>
                                                        UPSC Sociology Mains Test Series 2026
                                                </h2>
                                                <p className={styles.mobileSubTitle}>
                                                        Choose Your Best Fit
                                                </p>

                                                {/* FRESHERS  CARD */}

                                                <div className={styles.mobilePlanCard}>

                                                        <div className={styles.mobilePlanHeader}>
                                                                <div>
                                                                        <h3>FRESHERS</h3>
                                                                        <span>Ideal for Freshers</span>
                                                                </div>

                                                                <div className={styles.mobileBadge}>
                                                                        2026
                                                                </div>
                                                        </div>

                                                        <div className={styles.mobilePlanBody}>

                                                                <div className={styles.mobileInfoBox}>
                                                                        <h5>Whom?</h5>

                                                                        <p>
                                                                                Suits aspirants appearing for Mains 2026
                                                                        </p>
                                                                </div>

                                                                <div className={styles.mobileInfoBox}>
                                                                        <h5>Tests </h5>

                                                                        <p>
                                                                                6 Sectional Test + 4 Full Test
                                                                        </p>
                                                                </div>

                                                                <div className="text-center pt-2">

                                                                        <a
                                                                                // href="#"
                                                                                href="https://www.shankariasacademy.com/pdf/UPSC-2026/Moksha-Optional/Sociology/Sociology-Freshers-2026.pdf"
                                                                                target="_blank"
                                                                                className={styles.pdfBtn}
                                                                        >
                                                                                {/* <i className="bi bi-file-earmark-pdf-fill"> </i> */}
                                                                                <i className="bi bi-file-earmark-pdf-fill"></i>

                                                                               View PDF

                                                                        </a>
                                                                </div>
                                                                <div className="text-center pt-3">
                                                                        <a
                                                                                href="https://admissionsv1.shankariasacademy.com/"
                                                                                target="_blank"
                                                                                className={styles.mobileApplyBtn}
                                                                        >
                                                                                Pay Now
                                                                        </a>
                                                                </div>
                                                        </div>
                                                </div>

                                                {/* BEGINNER CARD */}

                                                <div className={styles.mobilePlanCard}>

                                                        <div className={styles.mobilePlanHeader}>
                                                                <div>
                                                                        <h3>VETERANS</h3>
                                                                        <span>Experienced</span>
                                                                </div>

                                                                <div className={styles.mobileBadge}>
                                                                        2026
                                                                </div>
                                                        </div>

                                                        <div className={styles.mobilePlanBody}>

                                                                <div className={styles.mobileInfoBox}>
                                                                        <h5>Whom?</h5>

                                                                        <p>
                                                                               Suits aspirants with prior mains experience and appearing for Mains 2026
                                                                        </p>
                                                                </div>

                                                                <div className={styles.mobileInfoBox}>
                                                                        <h5>Tests </h5>

                                                                        <p>
                                                                               6 Full Tests
                                                                        </p>
                                                                </div>

                                                                <div className="text-center pt-2">

                                                                        <a
                                                                                // href="#"
                                                                                href="https://www.shankariasacademy.com/pdf/UPSC-2026/Moksha-Optional/Sociology/Sociology-Veterans-2026.pdf"
                                                                                target="_blank"
                                                                                className={styles.pdfBtn}
                                                                        >
                                                                                {/* <i className="bi bi-file-earmark-pdf-fill"> </i> */}
                                                                                <i className="bi bi-file-earmark-pdf-fill"></i>

                                                                                View PDF

                                                                        </a>
                                                                </div>
                                                                <div className="text-center pt-3">
                                                                        <a
                                                                                href="https://admissionsv1.shankariasacademy.com/"
                                                                                target="_blank"
                                                                                className={styles.mobileApplyBtn}
                                                                        >
                                                                                Apply Now
                                                                        </a>
                                                                </div>
                                                        </div>
                                                </div>


                                                {/* LONG TERM CARD */}

                                                <div className={styles.mobilePlanCard}>

                                                        <div className={styles.mobilePlanHeader}>
                                                                <div>
                                                                        <h3>LONG TERM</h3>
                                                                        <span>Exhaustive Practice</span>
                                                                </div>

                                                                <div className={styles.mobileBadge}>
                                                                        2027
                                                                </div>
                                                        </div>

                                                        <div className={styles.mobilePlanBody}>

                                                                <div className={styles.mobileInfoBox}>
                                                                        <h5>Whom?</h5>

                                                                        <p>
                                                                                Suits aspirants who want exhaustive optional answer writing practice for Mains 2027
                                                                        </p>
                                                                </div>

                                                                <div className={styles.mobileInfoBox}>
                                                                        <h5>Tests </h5>

                                                                        <p>
                                                                               7 Sectional Test + 3 Revision Test + 2 Full Test
                                                                        </p>
                                                                </div>

                                                                <div className="text-center pt-2">

                                                                         <a
                                                                                // href="#"
                                                                                href="https://www.shankariasacademy.com/pdf/UPSC-2026/Moksha-Optional/Sociology/Sociology-LongTerm-2026.pdf"
                                                                                target="_blank"
                                                                                className={styles.pdfBtn}
                                                                        >
                                                                                {/* <i className="bi bi-file-earmark-pdf-fill"> </i> */}
                                                                                <i className="bi bi-file-earmark-pdf-fill"></i>

                                                                               View PDF

                                                                        </a>

                                                                </div>

                                                                <div className="text-center pt-3">

                                                                        <a
                                                                                href="https://admissionsv1.shankariasacademy.com/"
                                                                                target="_blank"
                                                                                className={styles.mobileApplyBtn}
                                                                        >
                                                                                Apply Now
                                                                        </a>

                                                                </div>

                                                        </div>

                                                </div>

                                        </div>
                                </div>
                        </div>

                        <Upsc_toppers />



                        {/* <div className="container d-none d-md-block">  <h2 className={`${styles.sectiontitle1} mb-0 py-3`}>UPSC Sociology  Test Series 2024</h2>
        </div>
        
        <div className="container d-none d-md-block" style={{backgroundColor:"rgb(255, 242, 242)"}}>
                
                <div className={`${styles.classesborder} row`} style={{backgroundColor:"#FFFFFF"}}>
                <div className="col-md-4 border pt-3 pb-3 d-none d-md-block">
                        <p className={`${styles.mainshead} mb-0`}>Choose your Best Fit</p>
                </div>
                <div className="col-md-4 border pt-3 pb-3 d-none d-md-block">
                        <p className={`${styles.mainshead} mb-0`}>Freshers</p>
                </div>
                <div className="col-md-4 border pt-3 pb-3 d-none d-md-block">
                        <p className={`${styles.mainshead} mb-0`}>Veterans</p>
                </div>
                </div>
                <div className={`${styles.classesborder} row`}>
                <div className="col-md-12 d-block d-md-none">
                        <p className={`${styles.mainshead} mb-0`}>Choose your Best Fit</p>
                </div>
                <div className="col-12 col-md-4 border pt-3 pb-3">
                <p className={`${styles.subhead} mb-0 mb-md-2`}>Whom ?</p>
                </div>
                <div className="col-12 d-block d-md-none">
                        <p className={`${styles.bgboxbg} p-2`}>Freshers</p>
                </div>   
                <div className="col-12 col-md-4 border pt-3 pb-3">
                <p className={`${styles} mb-0 mb-md-2`}>Suits aspirants appearing for
                                Mains 2024

                </p>
                </div>
                <div className="col-12 d-block d-md-none">
                        <p className={`${styles.bgboxbg} p-2`}>Veterans</p>
                </div>
                <div className="col-12 col-md-4 border pt-3 pb-3">
                        <p className={`${styles} mb-0`}>Suits aspirants with prior mains experience and appearing for Mains 2024</p>
                </div>
                </div>
                <div className={`${styles.classesborder} row`}>
                <div className="col-md-12 d-block d-md-none">
                        <p className={`${styles.mainshead} mb-0`}>Choose your Best Fit</p>
                </div>
                <div className="col-12 col-md-4 border pt-3 pb-3">
                <p className={`${styles.subhead} mb-0 mb-md-2`}>Tests</p>
                </div>
                <div className="col-12 d-block d-md-none">
                        <p className={`${styles.bgboxbg} p-2`}>Freshers</p>
                </div>   
                <div className="col-12 col-md-4 border pt-3 pb-3">
                <p className={`${styles} mb-0 mb-md-2`}>6 sectional tests + 4 full tests

                </p>
                </div>
                <div className="col-12 d-block d-md-none">
                        <p className={`${styles.bgboxbg} p-2`}>Veterans</p>
                </div>
                <div className="col-12 col-md-4 border pt-3 pb-3">
                        <p className={`${styles} mb-0`}>6 full tests</p>
                </div>
                </div>
                <div className={`${styles.classesborder} row`}>
                <div className="col-md-12 d-block d-md-none">
                        <p className={`${styles.mainshead} mb-0`}>Choose your Best Fit</p>
                </div>
                <div className="col-12 col-md-4 border pt-3 pb-3">
                <p className={`${styles.subhead} mb-0 mb-md-2`}>Schedule</p>
                </div>
                <div className="col-12 d-block d-md-none">
                        <p className={`${styles.bgboxbg} p-2`}>Freshers</p>
                </div>   
                <div className="col-12 col-md-4 border pt-3 pb-3 text-center">
                <span className="d-inline-block pt-2 text-center"><a href="https://www.shankariasacademy.com/pdf/moksha-mains/sociology/2024-Socio-Freshersh.pdf" target="_blank" className={`${styles.paybill}`}><i className="bi bi-file-earmark-pdf-fill" style={{fontSize:"20px",color:"#DB1B0D"}}></i>Click here</a></span>                                       
                </div>
                <div className="col-12 d-block d-md-none">
                        <p className={`${styles.bgboxbg} p-2`}>Veterans</p>
                </div>
                <div className="col-12 col-md-4 border pt-3 pb-3 text-center">
                <span className="d-inline-block pt-2 text-center"><a href="https://www.shankariasacademy.com/pdf/moksha-mains/sociology/2024-Socio-Veterans.pdf" target="_blank" className={`${styles.paybill}`}><i className="bi bi-file-earmark-pdf-fill" style={{fontSize:"20px",color:"#DB1B0D"}}></i>Click here</a></span>
                </div>
                </div>
                <div className={`${styles.classesborder} row`}>
                <div className="col-md-12 d-block d-md-none">
                        <p className={`${styles.mainshead}`}>Choose your Best Fit</p>
                </div>
                <div className="col-12 col-md-4 border pt-3 pb-3">
                <p className={`${styles.subhead} mb-0 mb-md-2`}>Admission</p>
                </div>
                <div className="col-12 d-block d-md-none">
                        <p className={`${styles.bgboxbg} p-2`}>Freshers</p>
                </div>   
                <div className="col-12 col-md-4 border pt-3 pb-3 text-center">
                <span className="d-inline-block text-center"><a href="https://admissionsv1.shankariasacademy.com/" target="_blank" className={`${styles.normalbutton} d-inline-block text-center align-middle`}>Click here</a></span>
                </div>
                <div className="col-12 d-block d-md-none ">
                        <p className={`${styles.bgboxbg} p-2`}>Veterans</p>
                </div>
                <div className="col-12 col-md-4 border pt-3 pb-3 text-center">
                <span className="d-inline-block"><a href="https://admissionsv1.shankariasacademy.com/" target="_blank" className={`${styles.normalbutton} d-inline-block text-center align-middle`}>Click here</a></span>
                </div>
                </div>

        </div>  */}
                        {/* Mainst 2025*/}
                        {/* <div className="container d-none d-md-block">  <h2 className={`${styles.sectiontitle1} mb-0 py-3`}>UPSC Sociology Mains Test Series 2025
        </h2>
        </div> */}

                        {/* <div className="container d-none d-md-block pt-4" style={{backgroundColor:""}}>
                
                <div className={`${styles.classesborder} row`} style={{backgroundColor:"rgb(255, 242, 242)"}}>
                <div className="col-md-4 border pt-3 pb-3 d-none d-md-block">
                        <p className={`${styles.mainshead} mb-0`}>CHOOSE YOUR BEST FIT </p>
                </div>
                <div className="col-md-3 border pt-3 pb-3 d-none d-md-block">
                        <p className={`${styles.mainshead} mb-0`}>FRESHERS</p>
                </div>

                <div className="col-md-4 border pt-3 pb-3 d-none d-md-block">
                        <p className={`${styles.mainshead} mb-0`}>BEGINNER</p>
                </div>

                <div className="col-md-3 border pt-3 pb-3 d-none d-md-block">
                        <p className={`${styles.mainshead} mb-0`}>VETERANS</p>
                </div>

                <div className="col-md-4 border pt-3 pb-3 d-none d-md-block">
                        <p className={`${styles.mainshead} mb-0`}>LONG TERM</p>
                </div>
                </div>
                <div className={`${styles.classesborder} row`}>
                <div className="col-md-12 d-block d-md-none">
                        <p className={`${styles.mainshead} mb-0`}>Choose your Best Fit</p>
                </div>
                <div className="col-12 col-md-4 border pt-3 pb-3">
                <p className={`${styles.subhead} mb-0 mb-md-2`}>Whom ?</p>
                </div>
                <div className="col-12 d-block d-md-none">
                        <p className={`${styles.bgboxbg} p-2`}>BEGINNER</p>
                </div>   
                <div className="col-12 col-md-4 border pt-3 pb-3">
                <p className={`${styles} mb-0 mb-md-2`}>Suits freshers appearing for Mains 2026

                </p>
                </div>

                <div className="col-12 d-block d-md-none">
                        <p className={`${styles.bgboxbg} p-2`}>VETERANS</p>
                </div> 
                <div className="col-12 col-md-3 border pt-3 pb-3">
                        <p className={`${styles} mb-0`}>Suits aspirants with Prior mains experience and appearing for Mains 2025</p>
                </div>

                <div className="col-12 d-block d-md-none">
                        <p className={`${styles.bgboxbg} p-2`}>LONG TERM</p>
                </div>
                <div className="col-12 col-md-4 border pt-3 pb-3">
                        <p className={`${styles} mb-0`}>Suits aspirants who want exhaustive optional answer writing practice for Mains 2026
        </p>
                </div>
                </div>
                <div className={`${styles.classesborder} row`}>
                <div className="col-md-12 d-block d-md-none">
                        <p className={`${styles.mainshead} mb-0`}>Choose your Best Fit</p>
                </div>
                <div className="col-12 col-md-4 border pt-3 pb-3">
                <p className={`${styles.subhead} mb-0 mb-md-2`}>Tests</p>
                </div>
                <div className="col-12 d-block d-md-none">
                        <p className={`${styles.bgboxbg} p-2`}>BEGINNER</p>
                </div>   
                <div className="col-12 col-md-4 border pt-3 pb-3">
                <p className={`${styles} mb-0 mb-md-2`}>10 Unit Test + 4 Full Test


                </p>
                </div>

                <div className="col-12 d-block d-md-none">
                        <p className={`${styles.bgboxbg} p-2`}>VETERANS</p>
                </div>
                <div className="col-12 col-md-3 border pt-3 pb-3">
                        <p className={`${styles} mb-0`}>6 full Test</p>
                </div>


                <div className="col-12 d-block d-md-none">
                        <p className={`${styles.bgboxbg} p-2`}>LONG TERM</p>
                </div>
                <div className="col-12 col-md-4 border pt-3 pb-3">
                        <p className={`${styles} mb-0`}>7 Sectional Test + 3 Revison Test + 2 Full Test</p>
                </div>
                </div>
                <div className={`${styles.classesborder} row`}>
                <div className="col-md-12 d-block d-md-none">
                        <p className={`${styles.mainshead} mb-0`}>Choose your Best Fit</p>
                </div>
                <div className="col-12 col-md-4 border pt-3 pb-3">
                        <p className={`${styles.mainshead} mb-0`}>Schedule</p>
                </div>
                
                <div className="col-12 d-block d-md-none">
                        <p className={`${styles.bgboxbg} p-2`}>BEGINNER</p>
                </div>   
                <div className="col-12 col-md-4 border pt-3 pb-3 text-center">
                <span className="d-inline-block pt-2"><a href="https://www.shankariasacademy.com/pdf/Moksha-Mains-2026/sociology/Sociology-Beginner-2026.pdf" target="_blank" className={`${styles.paybill}`}><i className="bi bi-file-earmark-pdf-fill" style={{fontSize:"20px",color:"#DB1B0D"}}></i>Click here</a></span>                                       
                </div>

                <div className="col-12 d-block d-md-none">
                        <p className={`${styles.bgboxbg} p-2`}>VETERANS</p>
                </div>
                <div className="col-12 col-md-3 border pt-3 pb-3 text-center">
                <span className="d-inline-block pt-2 text-center"><a href="https://www.shankariasacademy.com/pdf/Moksha-Mains-2026/sociology/Moksha-2025-sociology-optional-test-Veterans-R1-3.pdf" target="_blank" className={`${styles.paybill}`}><i className="bi bi-file-earmark-pdf-fill" style={{fontSize:"20px",color:"#DB1B0D"}}></i>Click here</a></span>                                       
                </div>

                <div className="col-12 d-block d-md-none">
                        <p className={`${styles.bgboxbg} p-2`}>LONG TERM</p>
                </div>
                <div className="col-12 col-md-4 border pt-3 pb-3 text-center">
                <span className="d-inline-block pt-2 text-center"><a href="https://www.shankariasacademy.com/pdf/Moksha-Mains-2026/sociology/Moksha-2025-sociology-optional-test-Long-Term-R1-3.pdf" target="_blank" className={`${styles.paybill}`}><i className="bi bi-file-earmark-pdf-fill" style={{fontSize:"20px",color:"#DB1B0D"}}></i>Click here</a></span>                                       
                </div>
                </div>
                <div className={`${styles.classesborder} row`}>
                <div className="col-md-12 d-block d-md-none">
                        <p className={`${styles.mainshead} mb-0`}>Choose your Best Fit</p>
                </div>
                <div className="col-12 col-md-4 border pt-3 pb-3">
                        <p className={`${styles.mainshead} mb-0`}>Admission</p>
                </div>
                <div className="col-12 d-block d-md-none">
                        <p className={`${styles.bgboxbg} p-2`}>BEGINNER</p>
                </div>   
                <div className="col-12 col-md-4 border pt-3 pb-3 text-center">
                <span className="d-inline-block"><a href="https://admissionsv1.shankariasacademy.com/" target="_blank" className={`${styles.normalbutton} d-inline-block text-center align-middle`}>Click here</a></span>
                </div>
                <div className="col-12 d-block d-md-none">
                        <p className={`${styles.bgboxbg} p-2`}>VETERANS</p>
                </div>

                <div className="col-12 col-md-3 border pt-3 pb-3 text-center">
                <span className="d-inline-block text-center"><a href="https://admissionsv1.shankariasacademy.com/" target="_blank" className={`${styles.normalbutton} d-inline-block text-center align-middle`}>Click here</a></span>
                </div>

                <div className="col-12 d-block d-md-none">
                        <p className={`${styles.bgboxbg} p-2`}>LONG TERM</p>
                </div>
                <div className="col-12 col-md-4 border pt-3 pb-3 text-center">
                <span className="d-inline-block text-center"><a href="https://admissionsv1.shankariasacademy.com/" target="_blank" className={`${styles.normalbutton} d-inline-block text-center align-middle`}>Click here</a></span>
                </div>
                </div>

        </div> */}


                        <Footer />
                </>
        )
}
export default UPSC_Main_Test_Series_2023;
